import { useState, useEffect, useCallback } from "react";

const lines = [
  "Velocity, Powered by Vigilance.",
  "Safe. Fast. Cost-efficient.",
];

const TypewriterCursive = () => {
  const [displayLines, setDisplayLines] = useState<string[]>(["", ""]);
  const [lineIndex, setLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [phase, setPhase] = useState<"typing" | "pause" | "clearing">("typing");

  const tick = useCallback(() => {
    if (phase === "typing") {
      const currentLine = lines[lineIndex];
      if (charIndex < currentLine.length) {
        setDisplayLines((prev) => {
          const next = [...prev];
          next[lineIndex] = currentLine.slice(0, charIndex + 1);
          return next;
        });
        setCharIndex((c) => c + 1);
      } else if (lineIndex < lines.length - 1) {
        setLineIndex((l) => l + 1);
        setCharIndex(0);
      } else {
        setPhase("pause");
      }
    } else if (phase === "pause") {
      setTimeout(() => {
        setPhase("clearing");
      }, 2000);
      return;
    } else if (phase === "clearing") {
      setDisplayLines(["", ""]);
      setLineIndex(0);
      setCharIndex(0);
      setPhase("typing");
    }
  }, [phase, lineIndex, charIndex]);

  useEffect(() => {
    const speed = phase === "typing" ? 80 : 0;
    const timer = setTimeout(tick, speed);
    return () => clearTimeout(timer);
  }, [tick, phase, charIndex, lineIndex]);

  return (
    <div className="min-h-[4.5rem] -mt-6 flex flex-col items-start" aria-label="Velocity, Powered by Vigilance. Safe. Fast. Cost-efficient.">
      {displayLines.map((text, i) => (
        <p
          key={i}
          className={`text-xl leading-relaxed tracking-wide font-display font-bold accent-text ${
            i === 1 ? "self-center opacity-80" : ""
          }`}
          style={{ minHeight: "2rem" }}
        >
          {text}
          {i === lineIndex && phase === "typing" && (
            <span className="inline-block w-[1.5px] h-[1.1em] bg-teal/40 ml-[2px] align-text-bottom animate-pulse" />
          )}
        </p>
      ))}
    </div>
  );
};

export default TypewriterCursive;
